var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasData
    ? _c(
        "div",
        [
          _c(
            "div",
            {
              ref: "avatarTooltip",
              staticClass: "thumbnail-group",
              class: _vm.thumbnailGroupClass,
            },
            _vm._l(_vm.visibleData, function (thumbnail, index) {
              return _c(
                "div",
                { key: index, staticClass: "thumbnail-item" },
                [
                  _c(
                    "profile-avatar",
                    _vm._b(
                      {
                        staticClass: "client-profile-owner-avatar",
                        class: { "mr-2": index > 0 },
                      },
                      "profile-avatar",
                      Object.assign({}, thumbnail),
                      false
                    )
                  ),
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "b-tooltip",
            {
              attrs: {
                target: _vm.getAvatarTooltipTarget,
                placement: _vm.placement,
                triggers: "hover",
              },
            },
            [
              _c(
                "div",
                _vm._l(_vm.tooltipData, function (thumbnail, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass:
                        "d-flex align-items-center justify-content-start px-2 py-1",
                    },
                    [
                      _c(
                        "profile-avatar",
                        _vm._b(
                          {
                            staticClass: "client-profile-owner-avatar mr-2",
                            attrs: { "avatar-options": { inline: false } },
                          },
                          "profile-avatar",
                          thumbnail,
                          false
                        )
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "tiny-font" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("nameFormat")(
                                thumbnail.givenName,
                                thumbnail.familyName
                              )
                            ) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  )
                }),
                0
              ),
            ]
          ),
        ],
        1
      )
    : _c(
        "div",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip",
              value: { title: _vm.emptyMessage, placement: _vm.placement },
              expression: "{ title: emptyMessage, placement }",
            },
          ],
          staticClass: "text-light-gray",
        },
        [
          _c("i", {
            staticClass: "fa fa-user-times",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }